import { Table } from '@tanstack/react-table';

import { Button } from './shadcn/button';

export function TableFooter<T>({ table, plural, className }: { table: Table<T>; plural: string; className?: string }) {
  return (
    <div className={`my-6 flex w-full items-center justify-between ${className}`}>
      <div className="mx-2 text-sm text-gray-500">
        Showing {table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1} to{' '}
        {Math.min(
          (table.getState().pagination.pageIndex + 1) * table.getState().pagination.pageSize,
          table.getFilteredRowModel().rows.length,
        )}{' '}
        of{' '}
        <span className="font-medium text-gray-600">
          {table.getFilteredRowModel().rows.length} {plural}
        </span>
      </div>

      <div className="flex items-center gap-2 text-gray-600">
        <p className="mx-4">
          Page {table.getState().pagination.pageIndex + 1} of{' '}
          {Math.ceil(table.getFilteredRowModel().rows.length / table.getState().pagination.pageSize)}
        </p>
        <Button onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
          Previous
        </Button>
        <Button onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
          Next
        </Button>
      </div>
    </div>
  );
}
